import { type NodeUserDataObject } from 'models/service';
import { type ApiClientResponse } from './deprecatedApi';
import { nodeApiClient, nodeApiRoutes, type PaginationData } from './nodeApi';

export const getUserIdFromLegacyId = async (userLegacyId: string) =>
  nodeApiClient.get<PaginationData<NodeUserDataObject>, ApiClientResponse<PaginationData<NodeUserDataObject>>>(
    nodeApiRoutes.members.getById(userLegacyId),
  );
